import type { FunctionComponent } from 'preact';
import { h } from 'preact';
import { useEffect, useRef } from 'preact/hooks';
import { Provider } from 'react-redux';

import { selectCustomerInitialized } from '../../../auth/store/auth.selectors';
import { selectProduct } from '../../../elements/store/element.selectors';
import { store } from '../../../store';
import { useAppSelector } from '../../../store/hooks';
import { useProductFormService } from '../../product-form-service.hook';

const ProductFormFallbackContent = () => {
  const productFormService = useProductFormService();
  const product = useAppSelector(selectProduct);
  const customerInitialized = useAppSelector(selectCustomerInitialized);
  const elementsRef = useRef<HTMLElement[]>([]);

  useEffect(() => {
    elementsRef.current = productFormService.startInitialization();
  }, [productFormService]);

  useEffect(() => {
    if (customerInitialized && product) {
      productFormService.initializeProductFormForProduct(product, elementsRef.current);
    }
  }, [product, customerInitialized, productFormService]);

  return <></>;
};

export const ProductFormFallbackComponent: FunctionComponent = () => {
  return (
    <Provider store={store}>
      <ProductFormFallbackContent />
    </Provider>
  );
};